import dynamic from "next/dynamic";
const TwoColIconBoxesImage = dynamic(() =>
  import("components/blocks/TwoColIconBoxesImage/TwoColIconBoxesImage")
);
const TwoColTextImage = dynamic(() =>
  import("components/blocks/TwoColTextImage/TwoColTextImage")
);
const PageIntro = dynamic(() =>
  import("components/content/PageIntro/PageIntro")
);
const RowCards = dynamic(() => import("components/blocks/RowCards/RowCards"));
const RowText = dynamic(() => import("components/blocks/RowText/RowText"));

import styles from "./Blocks.module.scss";

export default function Blocks({ content }) {
  return (
    <div className={`${styles.container}`}>
      {content?.map((block, index) => {
        switch (block.__typename) {
          case "ComponentBlocksTwoColTextImage":
            return (
              <TwoColTextImage
                data={block}
                key={`${block.__typename}-${index}`}
              />
            );
          case "ComponentContentPageIntro":
            return (
              <PageIntro
                title={block?.page_title}
                description={block?.page_introduction}
                layout="imageRight"
                key={`${block.__typename}-${index}`}
              />
            );
          case "ComponentBlocksTwoColIconBoxesImage":
            return (
              <TwoColIconBoxesImage
                data={block}
                key={`${block.__typename}-${index}`}
              />
            );

          case "ComponentBlocksRowCards":
            return (
              <RowCards block={block} key={`${block.__typename}-${index}`} />
            );
          case "ComponentBlocksRowText":
            return (
              <RowText block={block} key={`${block.__typename}-${index}`} />
            );
          default:
            return null;
        }
      })}
    </div>
  );
}
